import { useStore, useTasksStore } from '@assets/model/Store';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { Slide, toast } from 'react-toastify';

export const ActiveJob = observer(() => {
    const activeJobToaster = useRef(null);
    const store = useStore();
    useEffect(() => {
        if (store.activeJob && store.activeJob.status == 'processing') {
            if (activeJobToaster.current == null) {
                activeJobToaster.current = toast.info(
                    `Analysis \r\n ${store.activeJob.task}`,
                    {
                        progress: 0,
                        autoClose: false,
                        closeButton: false
                    }
                );
            }

            const progress = Math.min(store.activeJob.progress || 0, 0.99);

            toast.update(activeJobToaster.current, {
                render: (
                    <span style={{ marginLeft: 'auto' }}>
                        {store.activeJob.task}{' '}
                        <b>{(progress * 100).toFixed(0)}%</b>
                    </span>
                ),
                progress
            });
        } else {
            if (activeJobToaster.current) {
                toast.dismiss(activeJobToaster.current);
                activeJobToaster.current = null;
            }
        }
    }, [store.activeJob]);

    useEffect(() => {
        if (!store.tasksLog) return;

        const firstTimeDontShow = store.taskLogsLastIdShown == null;

        // On first load (login or refresh), mark all existing jobs as seen without showing toasts
        if (firstTimeDontShow) {
            let biggestId = null;
            for (const jobId in toJS(store.tasksLog)) {
                if (biggestId == null || jobId > biggestId) {
                    biggestId = jobId;
                }
            }
            store.taskLogsLastIdShown = biggestId;
            return;
        }

        var biggestIdProcessed = null;
        const toastedTaskIds = new Set<string>();
        for (const jobId in toJS(store.tasksLog)) {
            if (jobId > biggestIdProcessed || biggestIdProcessed == null) {
                biggestIdProcessed = jobId;
            }

            if (jobId <= store.taskLogsLastIdShown) {
                continue;
            }

            const job = store.tasksLog[jobId];
            if (job.status != 'in_progress') continue;
            if (job.reportId !== store.selectedReportId) continue;
            if (toastedTaskIds.has(job.taskId)) continue;

            const taskDef = useTasksStore().get_task_definition(job.taskId);
            if (!taskDef) continue;

            toastedTaskIds.add(job.taskId);
            toast.info(`${taskDef.name} Started`, {
                progress: 0,
                autoClose: 5000,
                closeButton: true,
                transition: Slide
            });
        }

        if (biggestIdProcessed != null) {
            store.taskLogsLastIdShown = biggestIdProcessed;
        }
    }, [store.tasksLog]);
    return null;
});
